import getWindow from './isWindow';
import offset from './offset';
export default function height(node, client) {
  var win = getWindow(node);
  return win ? win.innerHeight : client ? node.clientHeight : offset(node).height;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-big-calendar/node_modules/dom-helpers/esm/height.js
// module id = 1299
// module chunks = 29